import { render, staticRenderFns } from "./Shareholders-structure.vue?vue&type=template&id=a9f5af30&scoped=true"
import script from "./Shareholders-structure.vue?vue&type=script&lang=js"
export * from "./Shareholders-structure.vue?vue&type=script&lang=js"
import style0 from "./Shareholders-structure.vue?vue&type=style&index=0&id=a9f5af30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f5af30",
  null
  
)

export default component.exports